import { useEffect, useRef } from 'react';
import { getEventsSocket } from '../services/eventsSocket';

/**
 * Subscribe to lead.activity IMPORT_PROGRESS over Socket.IO `/events`.
 * @param {(event: object) => void} onProgress
 */
export default function useImportProgress(onProgress) {
  const callbackRef = useRef(onProgress);
  callbackRef.current = onProgress;

  useEffect(() => {
    const activeSocket = getEventsSocket();
    if (!activeSocket) {
      return undefined;
    }
    const handleLeadActivity = (event) => {
      if (event?.activityType !== 'IMPORT_PROGRESS') {
        return;
      }
      callbackRef.current?.(event);
    };
    activeSocket.on('lead.activity', handleLeadActivity);
    return () => {
      activeSocket.off('lead.activity', handleLeadActivity);
    };
  }, []);
}
